module.exports = __webpack_public_path__ + "img/artpm.00051281.png";